import React, { Component } from 'react';
import { Button, Modal, Form, Row, Col} from 'react-bootstrap';
import axios from 'axios';

class DemoModal extends Component {

    constructor (props) {
        super(props);
        this.state = {
            showing: false,
            Name: '',
            Company: '',
            Email: '',
            Phone: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    handleChange (evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleClose() {
        this.setState({showing: false})
    }

    handleShow() {
        this.setState({showing: true})
    }

    submitForm() {
        axios({
            method: 'post',
            url: 'https://script.google.com/macros/s/AKfycbyjRO5pAjtXNN0f1wuert96t_1MirGgeJCO0TnacIw2YDnlwHc/exec',
            data: Object.entries(this.state)
                .map(([key, val]) => `${key}='${encodeURIComponent(val)}`)
                .join('&'),
            headers: {'Content-Type': 'application/x-www-form-urlencoded' }
        }).catch(function (response) {
                console.log(response)
                alert('Something went wrong - please try again.')
            });
        this.handleClose();
    }


    render () {
        return (
            <>
                <Button variant={this.props.variant} onClick={this.handleShow}>
                    {this.props.text_inside}
                </Button>
                <Modal show={this.state.showing} onHide={this.handleClose} size="lg"
                       aria-labelledby="contained-modal-title-vcenter"
                       centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Request Demo</Modal.Title>
                    </Modal.Header>
                    <Form>
                        <Modal.Body>
                            <div>Please fill in the information below and a member of our team will be in touch.</div>
                            <div><br/></div>
                            <Row>
                                <Col xs={12} md={6}>
                                    <Form.Group controlId="formGroupName">
                                        <Form.Label>Your Name</Form.Label>
                                        <Form.Control type="text" placeholder="Alexander Smith" name="Name" onChange={this.handleChange}/>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group controlId="formGroupCompany">
                                        <Form.Label>Company</Form.Label>
                                        <Form.Control type="text" placeholder="RiskTails" name="Company" onChange={this.handleChange}/>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group controlId="formGroupEmail">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control type="email" placeholder="asmith@risktails.github.io" name="Email" onChange={this.handleChange}/>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group controlId="formGroupCompany">
                                        <Form.Label>Contact Number</Form.Label>
                                        <Form.Control type="text" placeholder="+44 1234 567890" name="Phone" onChange={this.handleChange}/>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.submitForm}>
                                Send
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </>
        );
    }
}

export default DemoModal;